import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "slider",
    style: _normalizeStyle({ '--jsValue': _ctx.modelValue.h / 360, background: _ctx.gradient })
  }, [
    _createElementVNode("div", {
      ref: "container",
      class: "container",
      onPointerdown: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startDrag($event)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['knob', { active: !!_ctx.moveHandler }])
      }, null, 2 /* CLASS */)
    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */)
  ], 4 /* STYLE */))
}